import React from "react";

export const InlineSvg: React.FC<{ html: string; size?: number; className?: string }> = ({
  html, size = 16, className = ""
}) => (
  <span
    className={`mc-svg ${className}`}
    style={{ width: size, height: size, display: "inline-grid", placeItems: "center" }}
    aria-hidden
    dangerouslySetInnerHTML={{ __html: html }}
  />
);
